<template>
  <Toast :close-tip="true" :close-event="closeEvent">
    <div class="top-title">领取失败</div>
    <p class="info fail-receive">哎呀，来晚一步券被抢光了啦！<br>发起活动可能领更大额券哦~</p>
    <img src="@/assets/img/dialog-pic.png" srcset="@/assets/img/dialog-pic@2x.png 2x,@/assets/img/dialog-pic@3x.png 3x">
    <p class="btn" @click="share">查看其它优惠券</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'toast',
  props: {
    closeEvent: Function,
    event: Function
  },
  components: {
    Toast
  },
  methods: {
    share () {
      this.bury("share_coupon_1571229562021|12", "")
      // this.event();
      this.closeEvent();
    }
  }

}
</script>

<style lang="scss" scoped>
.info {
  margin: 10px 0 20px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
  line-height: 17px;
}
.top-title {
  margin: -5px auto 0;
  width: 144px;
  height: 38px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  background-image: url("./../../../assets/img/toast-red-title@2x.png");
  background: -webkit-image-set(
    url("./../../../assets/img/toast-red-title.png") 1x,
    url("./../../../assets/img/toast-red-title@2x.png") 2x,
    url("./../../../assets/img/toast-red-title@3x.png") 3x
  );
  background-size: 100%;
  background-repeat: no-repeat;
}
.btn {
  margin: 23px auto 0;
  width: 120px;
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  font-size: 12px;
  color: #FFF8EF;
  text-align: center;
  background-image: linear-gradient(0deg, #FF2B19 0%, #FF7664 100%);
  border-radius: 100px;
}
</style>